// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ck-a";
export var fulfillmentFormRail = "_ck-9";
export var headerTitleRow = "_ck-c";
export var orderDetailsWrapper = "_ck-7";
export var orderLinkTrigger = "_ck-2";
export var paymentInformationGrid = "_ck-h";
export var paymentSummaryColumn = "_ck-i";
export var shipmentContainer = "_ck-b";
export var shipmentDetailsMainPane = "_ck-8";
export var shipmentNavigationCard = "_ck-5";
export var shipmentNavigationRail = "_ck-3";
export var shipmentNavigationRailHeader = "_ck-4";
export var shipmentSummaryFact = "_ck-e";
export var shipmentSummaryGrid = "_ck-d";
export var shipmentSummaryMetadataRow = "_ck-f";
export var shipmentSummaryTags = "_ck-g";
export var shipmentWorkspace = "_ck-0";
export var shipmentWorkspaceContent = "_ck-6";
export var shipmentWorkspaceHeader = "_ck-1";